/*
 * @File index.js
 * @Description This File is for review(s) store module
 */
import state from '@/store/modules/reviews/state'
import mutations from '@/store/modules/reviews/mutations'
import actions from '@/store/modules/reviews/actions'
import getters from '@/store/modules/reviews/getters'

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
